const translations = {
  en: {
    common: { loading: "Loading...", error: "Error", success: "Success", save: "Save", cancel: "Cancel", confirm: "Confirm", search: "Search", back: "Back", next: "Next", previous: "Previous", close: "Close", send: "Send", delete: "Delete", edit: "Edit", view: "View", noResults: "No results found", seeMore: "See more", learnMore: "Learn more", startNow: "Start now", createAccount: "Create Account", login: "Login", logout: "Logout", register: "Sign up", profile: "Profile", settings: "Settings", help: "Help", support: "Support", home: "Home", explore: "Explore", language: "Language" },
    nav: {
      search: "Search products, brands and more...",
      searchMobile: "Search products...",
      messages: "Messages",
      cart: "Cart",
      favorites: "Favorites",
      notifications: "Notifications",
      login: "Login",
      signup: "Sign up",
      myProfile: "My Profile",
      myOrders: "My Orders",
      wallet: "Wallet",
      dashboard: "Dashboard",
      myStore: "My Store",
      myProducts: "My Products",
      addProduct: "Add Product",
      promoteStore: "Promote my store",
      adminPanel: "Admin Panel",
      supportChat: "Contact Support",
      helpCenter: "Help Center",
      logout: "Logout",
      products: "Products",
      stores: "Stores",
      categories: "Categories",
      offers: "Offers",
      bestSellers: "Best Sellers",
      news: "News",
      advertise: "Advertise Product",
      buyer: "Buyer",
      seller: "Seller",
      affiliate: "Affiliate",
      admin: "Admin (CEO)",
    },
    footer: {
      description: "Connecting people, creating opportunities. Buy, sell and advertise safely on a premium platform.",
      newsletter: "Receive exclusive offers",
      emailPlaceholder: "your@email.com",
      subscribe: "Subscribe",
      navigation: "Navigation",
      home: "Home",
      explore: "Explore",
      stores: "Stores",
      advertise: "Advertise",
      support: "Support",
      aboutUs: "About Us",
      faq: "Help Center (FAQ)",
      contact: "Contact",
      talkToSupport: "Contact Support",
      legal: "Legal",
      terms: "Terms of Use",
      privacy: "Privacy",
      security: "Security",
      rights: "All rights reserved",
      social: "Social",
      subscribePrompt: "Enter your email and be notified of the best promotions.",
      invalidEmail: "Enter a valid email",
      subscribeSuccess: "Subscription confirmed!",
      subscribeError: "Error subscribing",
    },
    auth: {
      login: "Login",
      register: "Sign up",
      email: "Email",
      password: "Password",
      fullName: "Full name",
      confirmPassword: "Confirm password",
      googleLogin: "Login with Google",
      haveAccount: "Already have an account?",
      noAccount: "Don't have an account?",
      loading: "Loading...",
      passwordsDontMatch: "Passwords do not match",
      invalidCredentials: "Incorrect email or password.",
      connectionError: "Connection error. Please try again.",
      yourName: "Your full name",
      yourEmail: "your@email.com",
      yourPassword: "Your password",
      confirmYourPassword: "Confirm your password",
      orContinueWith: "Or continue with",
      registerAs: "Register as",
      buyer: "Buyer",
      seller: "Seller",
      affiliate: "Affiliate",
      loggingIn: "Logging in...",
      creating: "Creating...",
      loginSuccess: "Login successful!",
      registerSuccess: "Account created successfully!",
      registerError: "Error creating account",
    },
    home: {
      premiumMarketplace: "Premium Marketplace",
      futureOfShopping: "The future of shopping",
      partnerStores: "Partner Stores",
      sellOnBrane: "Sell on BRANE with a premium storefront",
      createStore: "Create your store, advertise products and turn your brand into an experience.",
      learnMore: "Learn more",
      start: "Get started",
      thousandsOfProducts: "Thousands of products",
      bestOffers: "Best offers",
      guaranteedPurchase: "Guaranteed purchase",
      freeShipping: "Free shipping nationwide",
      newItemsDaily: "New items daily",
      unbeatablePrices: "Unbeatable prices",
      protectionEndToEnd: "End-to-end protection",
      trackingRealtime: "With real-time tracking",
      exploreProducts: "Explore products",
      wantToSell: "I want to sell",
      fastShipping: "Fast shipping",
      acrossBrazil: "nationwide",
      securePayment: "Secure payment",
      protectedEnvironment: "protected environment",
      easyReturn: "Easy returns",
      upTo7Days: "up to 7 days",
      realSupport: "Real support",
      humanService: "human service",
      flashOffers: "Flash offers",
      endsIn: "Ends in",
      sellOnBrane2: "Sell on BRANE",
      transformUnused: "Turn what you don't use into cash.",
      braneClub: "BRANE Club",
      becomeMember: "Become a member",
      exclusiveCoupons: "Exclusive coupons",
      viewCoupons: "View coupons",
      joinUs: "Join us",
      readyToStart: "Ready to start?",
      goToMarketplace: "Go to marketplace",
      technology: "Technology",
      fashion: "Fashion",
      home: "Home",
      beauty: "Beauty",
      sports: "Sports",
      automotive: "Automotive",
      games: "Games",
      popularCategories: "Popular categories",
      electronics: "Electronics",
      collectibles: "Collectibles",
      vehicles: "Vehicles",
      isBrane: "is BRANE.",
      heroSubtitle: "Technology, security and thousands of products in a premium storefront.",
      offers: "Offers",
      globalSuppliers: "Global suppliers",
      buyFromSuppliers: "Buy directly from suppliers",
      connectSupplier: "Connect your store to factories and distributors.",
      explore: "Explore",
      viewStores: "View stores",
      bLivre: "B Livre",
      buySellDirect: "Buy and sell directly",
      buySellCommunity: "Buy and sell directly with the community",
      classifiedAds: "Classified ads, direct chat and local opportunities.",
      exploreBLivre: "Explore B Livre",
    },
    admin: {
      admin: "Admin",
      dashboard: "Dashboard",
      users: "Users",
      ads: "Ads",
      messages: "Messages",
      banners: "Banners",
      reports: "Reports",
      complaints: "Complaints",
      financial: "Financial",
      support: "Support",
      settings: "Settings",
      search: "Search...",
      online: "online",
      offline: "offline",
      backToMarketplace: "Back to marketplace",
      products: "Products",
      orders: "Orders",
      sales: "Sales",
      commissions: "Commissions",
      pendingOrders: "Pending Orders",
      pendingWithdrawals: "Pending Withdrawals",
      storeApproval: "Store Approval",
      loading: "Loading...",
      reactivated: "Ad reactivated",
      hidden: "Ad hidden",
      updateError: "Error updating status",
      featured: "Ad featured",
      unfeatured: "Featured removed",
      featuredError: "Error toggling featured",
      all: "All",
      services: "Services",
      vacancies: "Vacancies",
      realEstate: "Real Estate",
      autos: "Autos",
      other: "Other",
      tickets: "Support tickets",
      userManagement: "User Management",
    },
    branpy: {
      title: "BRANPY v3.0",
      search: "Search tools…",
      new: "New",
      home: "Home",
      favorites: "Favorites",
      all: "All",
      toolUnderConstruction: "Tool under construction",
      back: "Back",
      openTool: "Open tool",
      categories: {
        create: "Create", ai: "AI", business: "Business", marketing: "Marketing",
        developer: "Developer", media: "Media", productivity: "Productivity",
        automation: "Automation", cloud: "Cloud", future: "Labs",
      },
    },
    support: {
      title: "BRANE Support",
      subtitle: "We're here to help",
      description: "Send us your message and we'll respond as soon as possible.",
      placeholder: "Type your message...",
      viewHistory: "View history",
      send: "Send",
      sent: "Message sent to support!",
      error: "Error sending message",
      subject: "Subject",
      describeProblem: "Describe your problem...",
    },
    product: {
      notFound: "Product not found",
      addToCart: "Add to Cart",
      buyNow: "Buy Now",
      share: "Share",
      categories: "Categories",
      relatedProducts: "Related Products",
      outOfStock: "Out of stock",
      inStock: "In stock",
      description: "Description",
      reviews: "Reviews",
      specifications: "Specifications",
      price: "Price",
      quantity: "Quantity",
      shipping: "Shipping",
      calculateShipping: "Calculate shipping",
    },
    cart: {
      title: "Cart",
      empty: "Cart is empty",
      viewProducts: "View Products",
      removed: "Item removed",
      checkout: "Checkout",
      total: "Total",
      subtotal: "Subtotal",
      discount: "Discount",
      continueShopping: "Continue Shopping",
    },
    checkout: {
      title: "Checkout",
      emptyCart: "Empty cart",
      finishOrder: "Finish Order",
      address: "Address",
      payment: "Payment",
      shipping: "Shipping",
      orderSummary: "Order Summary",
      placeOrder: "Place Order",
      loadError: "Error loading checkout",
      orderError: "Error completing order",
    },
    wallet: {
      title: "Wallet",
      balance: "Balance",
      transactions: "Transactions",
      deposit: "Deposit",
      withdraw: "Withdraw",
      history: "History",
    },
    store: {
      title: "My Store",
      products: "My Products",
      addProduct: "Add Product",
      editProduct: "Edit Product",
      orders: "Orders",
      stats: "Statistics",
      promote: "Promote my store",
    },
    profile: {
      title: "My Profile",
      security: "Security",
      photoUpdated: "Photo updated!",
      save: "Save",
      personalData: "Personal Data",
      changePassword: "Change Password",
    },
    notification: {
      title: "Notifications",
      empty: "No notifications",
      markAllRead: "Mark all as read",
    },
    pwa: {
      install: "Install App",
      installTitle: "Install BRANE",
      description: "Install this app on your device for a better experience",
    },
    orders: {
      title: "My Orders",
      empty: "No orders yet",
      status: {
        pending: "Pending",
        confirmed: "Confirmed",
        processing: "Processing",
        shipped: "Shipped",
        delivered: "Delivered",
        cancelled: "Cancelled",
        refunded: "Refunded",
      },
    },
  },

  pt: {
    common: { loading: "Carregando...", error: "Erro", success: "Sucesso", save: "Salvar", cancel: "Cancelar", confirm: "Confirmar", search: "Buscar", back: "Voltar", next: "Próximo", previous: "Anterior", close: "Fechar", send: "Enviar", delete: "Excluir", edit: "Editar", view: "Visualizar", noResults: "Nenhum resultado encontrado", seeMore: "Ver mais", learnMore: "Saiba mais", startNow: "Começar agora", createAccount: "Criar Conta", login: "Entrar", logout: "Sair", register: "Cadastre-se", profile: "Perfil", settings: "Configurações", help: "Ajuda", support: "Suporte", home: "Início", explore: "Explorar", language: "Idioma" },
    nav: {
      search: "Buscar produtos, marcas e mais...",
      searchMobile: "Buscar produtos...",
      messages: "Mensagens",
      cart: "Carrinho",
      favorites: "Favoritos",
      notifications: "Notificações",
      login: "Entrar",
      signup: "Cadastre-se",
      myProfile: "Meu Perfil",
      myOrders: "Meus Pedidos",
      wallet: "Carteira",
      dashboard: "Painel",
      myStore: "Minha Loja",
      myProducts: "Meus Produtos",
      addProduct: "Adicionar Produto",
      promoteStore: "Promover minha loja",
      adminPanel: "Painel Admin",
      supportChat: "Falar com Suporte",
      helpCenter: "Central de Ajuda",
      logout: "Sair da Conta",
      products: "Produtos",
      stores: "Lojas",
      categories: "Categorias",
      offers: "Ofertas",
      bestSellers: "Mais vendidos",
      news: "Novidades",
      advertise: "Anunciar produto",
      buyer: "Comprador",
      seller: "Vendedor",
      affiliate: "Afiliado",
      admin: "Admin (CEO)",
    },
    footer: {
      description: "Conectando pessoas, criando oportunidades. Compre, venda e anuncie com segurança em uma plataforma premium.",
      newsletter: "Receba ofertas exclusivas",
      emailPlaceholder: "seuemail@exemplo.com",
      subscribe: "Inscrever",
      navigation: "Navegação",
      home: "Início",
      explore: "Explorar",
      stores: "Lojas",
      advertise: "Anunciar",
      support: "Suporte",
      aboutUs: "Sobre Nós",
      faq: "Central de ajuda (FAQ)",
      contact: "Contato",
      talkToSupport: "Falar com Suporte",
      legal: "Legal",
      terms: "Termos de uso",
      privacy: "Privacidade",
      security: "Segurança",
      rights: "Todos os direitos reservados",
      social: "Redes Sociais",
    },
    auth: {
      login: "Entrar",
      register: "Cadastre-se",
      email: "Email",
      password: "Senha",
      fullName: "Nome completo",
      confirmPassword: "Confirmar senha",
      googleLogin: "Entrar com Google",
      haveAccount: "Já tem uma conta?",
      noAccount: "Não tem conta?",
      loading: "Carregando...",
      passwordsDontMatch: "As senhas não coincidem",
      invalidCredentials: "Email ou senha incorretos.",
      connectionError: "Erro de conexão. Tente novamente.",
      yourName: "Seu nome completo",
      yourEmail: "seu@email.com",
      yourPassword: "Sua senha",
      confirmYourPassword: "Confirme sua senha",
      orContinueWith: "Ou continue com",
      registerAs: "Cadastrar como",
      buyer: "Comprador",
      seller: "Vendedor",
      affiliate: "Afiliado",
      loggingIn: "Entrando...",
      creating: "Criando...",
      loginSuccess: "Login realizado!",
      registerSuccess: "Conta criada com sucesso!",
      registerError: "Erro ao criar conta",
    },
    home: {
      premiumMarketplace: "Marketplace Premium",
      futureOfShopping: "O futuro das compras",
      partnerStores: "Lojas Parceiras",
      sellOnBrane: "Venda na BRANE com uma vitrine premium",
      createStore: "Crie sua loja, anuncie produtos e transforme sua marca em experiência.",
      learnMore: "Saiba mais",
      start: "Começar",
      thousandsOfProducts: "Milhares de produtos",
      bestOffers: "As melhores ofertas",
      guaranteedPurchase: "Compra garantida",
      freeShipping: "Frete para todo o Brasil",
      newItemsDaily: "Novos itens todos os dias",
      unbeatablePrices: "Preços imbatíveis",
      protectionEndToEnd: "Proteção do início ao fim",
      trackingRealtime: "Com rastreio em tempo real",
      exploreProducts: "Explorar produtos",
      wantToSell: "Quero vender",
      fastShipping: "Frete rápido",
      acrossBrazil: "para todo o Brasil",
      securePayment: "Pagamento seguro",
      protectedEnvironment: "ambiente protegido",
      easyReturn: "Devolução fácil",
      upTo7Days: "até 7 dias",
      realSupport: "Suporte real",
      humanService: "atendimento humano",
      flashOffers: "Ofertas relâmpago",
      endsIn: "Termina em",
      sellOnBrane2: "Venda na BRANE",
      transformUnused: "Transforme o que você não usa em dinheiro.",
      braneClub: "Clube BRANE",
      becomeMember: "Seja membro",
      exclusiveCoupons: "Cupons exclusivos",
      viewCoupons: "Ver cupons",
      joinUs: "Junte-se a nós",
      readyToStart: "Pronto para começar?",
      goToMarketplace: "Ir para o marketplace",
      technology: "Tecnologia",
      fashion: "Moda",
      home: "Casa",
      beauty: "Beleza",
      sports: "Esportes",
      automotive: "Auto",
      games: "Games",
      popularCategories: "Categorias populares",
      electronics: "Eletrônicos",
      collectibles: "Colecionáveis",
      vehicles: "Veículos",
      isBrane: "é BRANE.",
      heroSubtitle: "Tecnologia, segurança e milhares de produtos em uma vitrine premium.",
      offers: "Ofertas",
      globalSuppliers: "Fornecedores globais",
      buyFromSuppliers: "Compre direto de fornecedores",
      connectSupplier: "Conecte sua loja a fábricas e distribuidoras.",
      explore: "Explorar",
      viewStores: "Ver lojas",
      bLivre: "B Livre",
      buySellDirect: "Compre e venda direto",
      buySellCommunity: "Compre e venda direto com a comunidade",
      classifiedAds: "Anúncios classificados, chat direto e oportunidades locais.",
      exploreBLivre: "Explorar B Livre",
    },
    admin: {
      admin: "Admin",
      dashboard: "Dashboard",
      users: "Usuários",
      ads: "Anúncios",
      messages: "Mensagens",
      banners: "Banners",
      reports: "Relatórios",
      complaints: "Denúncias",
      financial: "Financeiro",
      support: "Suporte",
      settings: "Configurações",
      search: "Buscar...",
      online: "online",
      offline: "offline",
      backToMarketplace: "Voltar ao marketplace",
      products: "Produtos",
      orders: "Pedidos",
      sales: "Vendas",
      commissions: "Comissões",
      pendingOrders: "Pedidos Pend.",
      pendingWithdrawals: "Saques Pend.",
      storeApproval: "Aprovação de Lojas",
      loading: "Carregando...",
      reactivated: "Anúncio reativado",
      hidden: "Anúncio ocultado",
      updateError: "Erro ao atualizar status",
      featured: "Anúncio destacado",
      unfeatured: "Destaque removido",
      featuredError: "Erro ao alternar destaque",
      all: "Todas",
      services: "Serviços",
      vacancies: "Vagas",
      realEstate: "Imóveis",
      autos: "Autos",
      other: "Outros",
      tickets: "Tickets de suporte",
      userManagement: "Gestão de Usuários",
    },
    branpy: {
      title: "BRANPY v3.0",
      search: "Buscar ferramentas…",
      new: "Novo",
      home: "Início",
      favorites: "Favoritos",
      all: "Todas",
      toolUnderConstruction: "Ferramenta em construção",
      back: "Voltar",
      openTool: "Abrir ferramenta",
      categories: {
        create: "Criar", ai: "IA", business: "Negócios", marketing: "Marketing",
        developer: "Desenvolvedor", media: "Mídia", productivity: "Produtividade",
        automation: "Automação", cloud: "Nuvem", future: "Labs",
      },
    },
    support: {
      title: "Suporte BRANE",
      subtitle: "Estamos aqui para ajudar",
      description: "Envie sua mensagem e responderemos o mais rápido possível.",
      placeholder: "Digite sua mensagem...",
      viewHistory: "Ver histórico",
      send: "Enviar",
      sent: "Mensagem enviada ao suporte!",
      error: "Erro ao enviar",
      subject: "Assunto",
      describeProblem: "Descreva seu problema...",
    },
    product: {
      notFound: "Produto não encontrado",
      addToCart: "Adicionar ao carrinho",
      buyNow: "Comprar agora",
      share: "Compartilhar",
      categories: "Categorias",
      relatedProducts: "Produtos relacionados",
      outOfStock: "Fora de estoque",
      inStock: "Em estoque",
      description: "Descrição",
      reviews: "Avaliações",
      specifications: "Especificações",
      price: "Preço",
      quantity: "Quantidade",
      shipping: "Frete",
      calculateShipping: "Calcular frete",
    },
    cart: {
      title: "Carrinho",
      empty: "Carrinho vazio",
      viewProducts: "Ver Produtos",
      removed: "Item removido",
      checkout: "Finalizar compra",
      total: "Total",
      subtotal: "Subtotal",
      discount: "Desconto",
      continueShopping: "Continuar Comprando",
    },
    checkout: {
      title: "Finalizar Compra",
      emptyCart: "Carrinho vazio",
      finishOrder: "Finalizar Pedido",
      address: "Endereço",
      payment: "Pagamento",
      shipping: "Frete",
      orderSummary: "Resumo do Pedido",
      placeOrder: "Confirmar Pedido",
      loadError: "Erro ao carregar checkout",
      orderError: "Erro ao finalizar pedido",
    },
    wallet: {
      title: "Carteira",
      balance: "Saldo",
      transactions: "Transações",
      deposit: "Depositar",
      withdraw: "Sacar",
      history: "Histórico",
    },
    store: {
      title: "Minha Loja",
      products: "Meus Produtos",
      addProduct: "Adicionar Produto",
      editProduct: "Editar Produto",
      orders: "Pedidos",
      stats: "Estatísticas",
      promote: "Promover minha loja",
    },
    profile: {
      title: "Meu Perfil",
      security: "Segurança",
      photoUpdated: "Foto atualizada!",
      save: "Salvar",
      personalData: "Dados Pessoais",
      changePassword: "Alterar Senha",
    },
    notification: {
      title: "Notificações",
      empty: "Sem notificações",
      markAllRead: "Marcar todas como lidas",
    },
    pwa: {
      install: "Instalar aplicativo",
      installTitle: "Instalar BRANE",
      description: "Instale este aplicativo no seu dispositivo para uma melhor experiência",
    },
    orders: {
      title: "Meus Pedidos",
      empty: "Nenhum pedido ainda",
      status: {
        pending: "Pendente",
        confirmed: "Confirmado",
        processing: "Processando",
        shipped: "Enviado",
        delivered: "Entregue",
        cancelled: "Cancelado",
        refunded: "Reembolsado",
      },
    },
  },

  it: {
    common: { loading: "Caricamento...", error: "Errore", success: "Successo", save: "Salva", cancel: "Annulla", confirm: "Conferma", search: "Cerca", back: "Indietro", next: "Avanti", close: "Chiudi", send: "Invia", delete: "Elimina", edit: "Modifica", view: "Visualizza", noResults: "Nessun risultato trovato", seeMore: "Vedi altro", learnMore: "Scopri di più", startNow: "Inizia ora", createAccount: "Crea Account", login: "Accedi", logout: "Esci", register: "Registrati", profile: "Profilo", settings: "Impostazioni", help: "Aiuto", support: "Supporto", home: "Home", explore: "Esplora", language: "Lingua" },
    nav: {
      search: "Cerca prodotti, marche e altro...",
      searchMobile: "Cerca prodotti...",
      messages: "Messaggi",
      cart: "Carrello",
      favorites: "Preferiti",
      notifications: "Notifiche",
      login: "Accedi",
      signup: "Registrati",
      myProfile: "Il Mio Profilo",
      myOrders: "I Miei Ordini",
      wallet: "Portafoglio",
      dashboard: "Pannello",
      myStore: "Il Mio Negozio",
      myProducts: "I Miei Prodotti",
      addProduct: "Aggiungi Prodotto",
      promoteStore: "Promuovi il mio negozio",
      adminPanel: "Pannello Admin",
      supportChat: "Contatta Supporto",
      helpCenter: "Centro Aiuto",
      logout: "Esci",
      products: "Prodotti",
      stores: "Negozi",
      categories: "Categorie",
      offers: "Offerte",
      bestSellers: "Più venduti",
      news: "Novità",
      advertise: "Pubblicizza Prodotto",
      buyer: "Acquirente",
      seller: "Venditore",
      affiliate: "Affiliato",
      admin: "Admin (CEO)",
    },
    footer: {
      description: "Connettere persone, creare opportunità. Acquista, vendi e pubblicizza in sicurezza su una piattaforma premium.",
      newsletter: "Ricevi offerte esclusive",
      emailPlaceholder: "tua@email.com",
      subscribe: "Iscriviti",
      navigation: "Navigazione",
      home: "Home",
      explore: "Esplora",
      stores: "Negozi",
      advertise: "Pubblicizza",
      support: "Supporto",
      aboutUs: "Chi Siamo",
      faq: "Centro Aiuto (FAQ)",
      contact: "Contatti",
      talkToSupport: "Contatta Supporto",
      legal: "Legale",
      terms: "Termini di Utilizzo",
      privacy: "Privacy",
      security: "Sicurezza",
      rights: "Tutti i diritti riservati",
      social: "Social",
    },
    auth: { login: "Accedi", register: "Registrati", email: "Email", password: "Password", fullName: "Nome completo", confirmPassword: "Conferma password", googleLogin: "Accedi con Google", haveAccount: "Hai già un account?", noAccount: "Non hai un account?", loading: "Caricamento...", passwordsDontMatch: "Le password non coincidono", invalidCredentials: "Email o password errati.", connectionError: "Errore di connessione. Riprova.", yourName: "Il tuo nome completo", yourEmail: "tua@email.com", yourPassword: "La tua password", confirmYourPassword: "Conferma la tua password", orContinueWith: "O continua con" },
    home: {
      premiumMarketplace: "Marketplace Premium",
      futureOfShopping: "Il futuro dello shopping",
      partnerStores: "Negozi Partner",
      sellOnBrane: "Vendi su BRANE con una vetrina premium",
      createStore: "Crea il tuo negozio, pubblicizza prodotti e trasforma il tuo marchio in un'esperienza.",
      learnMore: "Scopri di più",
      start: "Inizia",
      thousandsOfProducts: "Migliaia di prodotti",
      bestOffers: "Le migliori offerte",
      guaranteedPurchase: "Acquisto garantito",
      freeShipping: "Spedizione gratuita in tutto il Brasile",
      newItemsDaily: "Nuovi articoli ogni giorno",
      unbeatablePrices: "Prezzi imbattibili",
      protectionEndToEnd: "Protezione dall'inizio alla fine",
      trackingRealtime: "Con tracciamento in tempo reale",
      exploreProducts: "Esplora prodotti",
      wantToSell: "Voglio vendere",
      flashOffers: "Offerte lampo",
      endsIn: "Termina tra",
      sellOnBrane2: "Vendi su BRANE",
      transformUnused: "Trasforma ciò che non usi in denaro.",
      joinUs: "Unisciti a noi",
      readyToStart: "Pronto per iniziare?",
      goToMarketplace: "Vai al marketplace",
      technology: "Tecnologia",
      fashion: "Moda",
      home: "Casa",
      beauty: "Bellezza",
      sports: "Sport",
      automotive: "Auto",
      games: "Giochi",
    },
    branpy: {
      title: "BRANPY v3.0",
      search: "Cerca strumenti…",
      new: "Nuovo",
      home: "Home",
      favorites: "Preferiti",
      all: "Tutti",
      toolUnderConstruction: "Strumento in costruzione",
      back: "Indietro",
      openTool: "Apri strumento",
      categories: { create: "Crea", ai: "IA", business: "Business", marketing: "Marketing", developer: "Sviluppatore", media: "Media", productivity: "Produttività", automation: "Automazione", cloud: "Cloud", future: "Labs" },
    },
    product: { notFound: "Prodotto non trovato", addToCart: "Aggiungi al Carrello", buyNow: "Acquista Ora", share: "Condividi", relatedProducts: "Prodotti correlati" },
    cart: { title: "Carrello", empty: "Carrello vuoto", viewProducts: "Vedi Prodotti", checkout: "Checkout" },
    support: { title: "Supporto BRANE", subtitle: "Siamo qui per aiutarti", placeholder: "Scrivi il tuo messaggio...", send: "Invia", sent: "Messaggio inviato al supporto!", error: "Errore nell'invio" },
  },

  es: {
    common: { loading: "Cargando...", error: "Error", success: "Éxito", save: "Guardar", cancel: "Cancelar", confirm: "Confirmar", search: "Buscar", back: "Volver", next: "Siguiente", close: "Cerrar", send: "Enviar", delete: "Eliminar", edit: "Editar", view: "Ver", noResults: "Sin resultados", seeMore: "Ver más", learnMore: "Saber más", startNow: "Empezar ahora", createAccount: "Crear Cuenta", login: "Iniciar sesión", logout: "Cerrar sesión", register: "Registrarse", profile: "Perfil", settings: "Ajustes", help: "Ayuda", support: "Soporte", home: "Inicio", explore: "Explorar", language: "Idioma" },
    nav: {
      search: "Buscar productos, marcas y más...",
      searchMobile: "Buscar productos...",
      messages: "Mensajes",
      cart: "Carrito",
      favorites: "Favoritos",
      notifications: "Notificaciones",
      login: "Iniciar sesión",
      signup: "Registrarse",
      myProfile: "Mi Perfil",
      myOrders: "Mis Pedidos",
      wallet: "Billetera",
      dashboard: "Panel",
      myStore: "Mi Tienda",
      myProducts: "Mis Productos",
      addProduct: "Añadir Producto",
      promoteStore: "Promocionar mi tienda",
      adminPanel: "Panel Admin",
      supportChat: "Hablar con Soporte",
      helpCenter: "Centro de Ayuda",
      logout: "Cerrar Sesión",
      products: "Productos",
      stores: "Tiendas",
      categories: "Categorías",
      offers: "Ofertas",
      bestSellers: "Más vendidos",
      news: "Novedades",
      advertise: "Anunciar Producto",
      buyer: "Comprador",
      seller: "Vendedor",
      affiliate: "Afiliado",
      admin: "Admin (CEO)",
    },
    footer: {
      description: "Conectando personas, creando oportunidades. Compra, vende y anuncia con seguridad en una plataforma premium.",
      newsletter: "Recibe ofertas exclusivas",
      emailPlaceholder: "tu@email.com",
      subscribe: "Suscribirse",
      navigation: "Navegación",
      home: "Inicio",
      explore: "Explorar",
      stores: "Tiendas",
      advertise: "Anunciar",
      support: "Soporte",
      aboutUs: "Sobre Nosotros",
      faq: "Centro de Ayuda (FAQ)",
      contact: "Contacto",
      talkToSupport: "Hablar con Soporte",
      legal: "Legal",
      terms: "Términos de Uso",
      privacy: "Privacidad",
      security: "Seguridad",
      rights: "Todos los derechos reservados",
      social: "Social",
    },
    auth: { login: "Iniciar sesión", register: "Registrarse", email: "Correo", password: "Contraseña", fullName: "Nombre completo", confirmPassword: "Confirmar contraseña", googleLogin: "Iniciar con Google", haveAccount: "¿Ya tienes cuenta?", noAccount: "¿No tienes cuenta?", loading: "Cargando...", passwordsDontMatch: "Las contraseñas no coinciden", invalidCredentials: "Correo o contraseña incorrectos.", connectionError: "Error de conexión. Intente de nuevo.", yourName: "Tu nombre completo", yourEmail: "tu@email.com", yourPassword: "Tu contraseña", confirmYourPassword: "Confirma tu contraseña", orContinueWith: "O continúa con" },
    home: {
      premiumMarketplace: "Marketplace Premium",
      futureOfShopping: "El futuro de las compras",
      partnerStores: "Tiendas Asociadas",
      sellOnBrane: "Vende en BRANE con una vitrina premium",
      createStore: "Crea tu tienda, anuncia productos y convierte tu marca en una experiencia.",
      learnMore: "Saber más",
      start: "Comenzar",
      thousandsOfProducts: "Miles de productos",
      bestOffers: "Las mejores ofertas",
      guaranteedPurchase: "Compra garantizada",
      freeShipping: "Envío gratis a todo Brasil",
      exploreProducts: "Explorar productos",
      wantToSell: "Quiero vender",
      flashOffers: "Ofertas relámpago",
      endsIn: "Termina en",
      sellOnBrane2: "Vende en BRANE",
      transformUnused: "Convierte lo que no usas en dinero.",
      joinUs: "Únete a nosotros",
      readyToStart: "¿Listo para empezar?",
      goToMarketplace: "Ir al marketplace",
      technology: "Tecnología",
      fashion: "Moda",
      home: "Hogar",
      beauty: "Belleza",
      sports: "Deportes",
      automotive: "Automotriz",
      games: "Juegos",
    },
    branpy: {
      title: "BRANPY v3.0",
      search: "Buscar herramientas…",
      new: "Nuevo",
      home: "Inicio",
      favorites: "Favoritos",
      all: "Todas",
      toolUnderConstruction: "Herramienta en construcción",
      back: "Volver",
      openTool: "Abrir herramienta",
      categories: { create: "Crear", ai: "IA", business: "Negocios", marketing: "Marketing", developer: "Desarrollador", media: "Media", productivity: "Productividad", automation: "Automatización", cloud: "Nube", future: "Labs" },
    },
    product: { notFound: "Producto no encontrado", addToCart: "Añadir al Carrito", buyNow: "Comprar Ahora", share: "Compartir", relatedProducts: "Productos relacionados" },
    cart: { title: "Carrito", empty: "Carrito vacío", viewProducts: "Ver Productos", checkout: "Finalizar compra" },
    support: { title: "Soporte BRANE", subtitle: "Estamos aquí para ayudar", placeholder: "Escribe tu mensaje...", send: "Enviar", sent: "¡Mensaje enviado al soporte!", error: "Error al enviar" },
  },

  fr: {
    common: { loading: "Chargement...", error: "Erreur", success: "Succès", save: "Enregistrer", cancel: "Annuler", confirm: "Confirmer", search: "Rechercher", back: "Retour", next: "Suivant", close: "Fermer", send: "Envoyer", delete: "Supprimer", edit: "Modifier", view: "Voir", noResults: "Aucun résultat", seeMore: "Voir plus", learnMore: "En savoir plus", startNow: "Commencer", createAccount: "Créer un Compte", login: "Connexion", logout: "Déconnexion", register: "S'inscrire", profile: "Profil", settings: "Paramètres", help: "Aide", support: "Support", home: "Accueil", explore: "Explorer", language: "Langue" },
    nav: {
      search: "Rechercher des produits, marques...",
      searchMobile: "Rechercher des produits...",
      messages: "Messages",
      cart: "Panier",
      favorites: "Favoris",
      notifications: "Notifications",
      login: "Connexion",
      signup: "S'inscrire",
      myProfile: "Mon Profil",
      myOrders: "Mes Commandes",
      wallet: "Portefeuille",
      dashboard: "Tableau de bord",
      myStore: "Ma Boutique",
      myProducts: "Mes Produits",
      addProduct: "Ajouter un Produit",
      promoteStore: "Promouvoir ma boutique",
      adminPanel: "Panneau Admin",
      supportChat: "Contacter le Support",
      helpCenter: "Centre d'Aide",
      logout: "Déconnexion",
      products: "Produits",
      stores: "Boutiques",
      categories: "Catégories",
      offers: "Offres",
      bestSellers: "Meilleures ventes",
      news: "Nouveautés",
      advertise: "Annoncer un Produit",
      buyer: "Acheteur",
      seller: "Vendeur",
      affiliate: "Affilié",
      admin: "Admin (CEO)",
    },
    footer: {
      description: "Connecter les gens, créer des opportunités. Achetez, vendez et annoncez en toute sécurité sur une plateforme premium.",
      newsletter: "Recevez des offres exclusives",
      emailPlaceholder: "votre@email.com",
      subscribe: "S'abonner",
      navigation: "Navigation",
      home: "Accueil",
      explore: "Explorer",
      stores: "Boutiques",
      advertise: "Annoncer",
      support: "Support",
      aboutUs: "À Propos",
      faq: "Centre d'Aide (FAQ)",
      contact: "Contact",
      talkToSupport: "Contacter le Support",
      legal: "Mentions Légales",
      terms: "Conditions d'Utilisation",
      privacy: "Confidentialité",
      security: "Sécurité",
      rights: "Tous droits réservés",
      social: "Réseaux",
    },
    auth: { login: "Connexion", register: "S'inscrire", email: "Email", password: "Mot de passe", fullName: "Nom complet", confirmPassword: "Confirmer le mot de passe", googleLogin: "Connexion avec Google", haveAccount: "Vous avez un compte?", noAccount: "Pas de compte?", loading: "Chargement...", passwordsDontMatch: "Les mots de passe ne correspondent pas", invalidCredentials: "Email ou mot de passe incorrect.", connectionError: "Erreur de connexion. Réessayez.", yourName: "Votre nom complet", yourEmail: "votre@email.com", yourPassword: "Votre mot de passe", confirmYourPassword: "Confirmez votre mot de passe", orContinueWith: "Ou continuez avec" },
    home: {
      premiumMarketplace: "Marketplace Premium",
      futureOfShopping: "L'avenir du shopping",
      partnerStores: "Magasins Partenaires",
      sellOnBrane: "Vendez sur BRANE avec une vitrine premium",
      exploreProducts: "Explorer les produits",
      wantToSell: "Je veux vendre",
      technology: "Technologie",
      fashion: "Mode",
      home: "Maison",
      beauty: "Beauté",
      sports: "Sports",
      automotive: "Auto",
      games: "Jeux",
    },
    branpy: {
      title: "BRANPY v3.0",
      search: "Rechercher des outils…",
      new: "Nouveau",
      home: "Accueil",
      favorites: "Favoris",
      all: "Tous",
      toolUnderConstruction: "Outil en construction",
      back: "Retour",
      openTool: "Ouvrir l'outil",
      categories: { create: "Créer", ai: "IA", business: "Affaires", marketing: "Marketing", developer: "Développeur", media: "Média", productivity: "Productivité", automation: "Automatisation", cloud: "Cloud", future: "Labs" },
    },
    cart: { title: "Panier", empty: "Panier vide" },
    support: { title: "Support BRANE", placeholder: "Tapez votre message...", send: "Envoyer", error: "Erreur d'envoi" },
  },

  de: {
    common: { loading: "Laden...", error: "Fehler", success: "Erfolg", save: "Speichern", cancel: "Abbrechen", confirm: "Bestätigen", search: "Suchen", back: "Zurück", next: "Weiter", close: "Schließen", send: "Senden", delete: "Löschen", edit: "Bearbeiten", view: "Ansehen", noResults: "Keine Ergebnisse", seeMore: "Mehr anzeigen", learnMore: "Mehr erfahren", startNow: "Jetzt starten", createAccount: "Konto erstellen", login: "Anmelden", logout: "Abmelden", register: "Registrieren", profile: "Profil", settings: "Einstellungen", help: "Hilfe", support: "Support", home: "Startseite", explore: "Entdecken", language: "Sprache" },
    nav: {
      search: "Produkte, Marken und mehr suchen...",
      messages: "Nachrichten",
      cart: "Warenkorb",
      favorites: "Favoriten",
      notifications: "Benachrichtigungen",
      login: "Anmelden",
      signup: "Registrieren",
      myProfile: "Mein Profil",
      myOrders: "Meine Bestellungen",
      wallet: "Geldbörse",
      dashboard: "Dashboard",
      myStore: "Mein Shop",
      myProducts: "Meine Produkte",
      addProduct: "Produkt hinzufügen",
      promoteStore: "Meinen Shop bewerben",
      adminPanel: "Admin-Bereich",
      supportChat: "Support kontaktieren",
      helpCenter: "Hilfe-Center",
      logout: "Abmelden",
      products: "Produkte",
      stores: "Shops",
      categories: "Kategorien",
      offers: "Angebote",
      bestSellers: "Bestseller",
      news: "Neuigkeiten",
      advertise: "Produkt bewerben",
      buyer: "Käufer",
      seller: "Verkäufer",
      affiliate: "Partner",
      admin: "Admin (CEO)",
    },
    footer: {
      description: "Menschen verbinden, Chancen schaffen. Kaufen, verkaufen und bewerben Sie sicher auf einer Premium-Plattform.",
      newsletter: "Exklusive Angebote erhalten",
      emailPlaceholder: "ihre@email.com",
      subscribe: "Abonnieren",
      navigation: "Navigation",
      home: "Startseite",
      support: "Support",
      privacy: "Datenschutz",
      rights: "Alle Rechte vorbehalten",
    },
    auth: { login: "Anmelden", register: "Registrieren", email: "E-Mail", password: "Passwort", loading: "Laden..." },
    branpy: { title: "BRANPY v3.0", search: "Werkzeuge suchen…", new: "Neu", home: "Startseite", favorites: "Favoriten", all: "Alle", back: "Zurück", categories: { create: "Erstellen", ai: "KI", business: "Geschäft", marketing: "Marketing", developer: "Entwickler", media: "Medien", productivity: "Produktivität", automation: "Automation", cloud: "Cloud", future: "Labs" } },
  },

  zh: {
    common: { loading: "加载中...", error: "错误", success: "成功", save: "保存", cancel: "取消", confirm: "确认", search: "搜索", back: "返回", next: "下一步", close: "关闭", send: "发送", delete: "删除", edit: "编辑", view: "查看", noResults: "未找到结果", seeMore: "查看更多", learnMore: "了解更多", startNow: "立即开始", createAccount: "创建账户", login: "登录", logout: "退出", register: "注册", profile: "个人资料", settings: "设置", help: "帮助", support: "支持", home: "首页", explore: "探索", language: "语言" },
    nav: {
      search: "搜索产品、品牌等...",
      messages: "消息",
      cart: "购物车",
      favorites: "收藏",
      notifications: "通知",
      login: "登录",
      signup: "注册",
      myProfile: "我的资料",
      myOrders: "我的订单",
      wallet: "钱包",
      dashboard: "控制面板",
      myStore: "我的店铺",
      myProducts: "我的产品",
      addProduct: "添加产品",
      promoteStore: "推广我的店铺",
      adminPanel: "管理面板",
      supportChat: "联系支持",
      helpCenter: "帮助中心",
      logout: "退出登录",
      products: "产品",
      stores: "店铺",
      categories: "分类",
      offers: "优惠",
      bestSellers: "畅销",
      news: "最新",
      advertise: "广告产品",
    },
    footer: {
      description: "连接人们，创造机会。在优质平台上安全购买、销售和广告。",
      newsletter: "接收独家优惠",
      emailPlaceholder: "您的@邮箱.com",
      subscribe: "订阅",
      navigation: "导航",
      rights: "保留所有权利",
    },
    branpy: { title: "BRANPY v3.0", search: "搜索工具...", new: "新建", favorites: "收藏", all: "全部", back: "返回", categories: { create: "创建", ai: "AI", business: "商业", marketing: "营销", developer: "开发者", media: "媒体", productivity: "效率", automation: "自动化", cloud: "云", future: "实验室" } },
  },

  ja: {
    common: { loading: "読み込み中...", error: "エラー", success: "成功", save: "保存", cancel: "キャンセル", confirm: "確認", search: "検索", back: "戻る", next: "次へ", close: "閉じる", send: "送信", delete: "削除", edit: "編集", view: "表示", noResults: "結果が見つかりません", seeMore: "もっと見る", learnMore: "詳細を見る", startNow: "今すぐ始める", createAccount: "アカウント作成", login: "ログイン", logout: "ログアウト", register: "登録", profile: "プロフィール", settings: "設定", help: "ヘルプ", support: "サポート", home: "ホーム", explore: "探索", language: "言語" },
    nav: {
      search: "商品やブランドを検索...",
      messages: "メッセージ",
      cart: "カート",
      favorites: "お気に入り",
      notifications: "通知",
      login: "ログイン",
      signup: "登録",
      myProfile: "マイプロフィール",
      myOrders: "マイ注文",
      wallet: "ウォレット",
      dashboard: "ダッシュボード",
      myStore: "マイショップ",
      myProducts: "マイ商品",
      addProduct: "商品追加",
      adminPanel: "管理パネル",
      logout: "ログアウト",
      products: "商品",
      stores: "ショップ",
      categories: "カテゴリー",
    },
    branpy: { title: "BRANPY v3.0", search: "ツールを検索...", new: "新規", favorites: "お気に入り", all: "すべて", back: "戻る", categories: { create: "作成", ai: "AI", business: "ビジネス", marketing: "マーケティング", developer: "開発者", media: "メディア", productivity: "生産性", automation: "自動化", cloud: "クラウド", future: "ラボ" } },
  },

  ar: {
    common: { loading: "جار التحميل...", error: "خطأ", success: "نجاح", save: "حفظ", cancel: "إلغاء", confirm: "تأكيد", search: "بحث", back: "رجوع", next: "التالي", close: "إغلاق", send: "إرسال", delete: "حذف", edit: "تعديل", view: "عرض", noResults: "لا توجد نتائج", seeMore: "عرض المزيد", learnMore: "اعرف المزيد", startNow: "ابدأ الآن", createAccount: "إنشاء حساب", login: "تسجيل الدخول", logout: "تسجيل الخروج", register: "التسجيل", profile: "الملف الشخصي", settings: "الإعدادات", help: "مساعدة", support: "الدعم", home: "الرئيسية", explore: "استكشاف", language: "اللغة" },
    nav: {
      search: "البحث عن المنتجات والعلامات التجارية...",
      messages: "الرسائل",
      cart: "السلة",
      favorites: "المفضلة",
      notifications: "الإشعارات",
      login: "تسجيل الدخول",
      signup: "التسجيل",
      myProfile: "ملفي الشخصي",
      myOrders: "طلباتي",
      wallet: "المحفظة",
      dashboard: "لوحة التحكم",
      myStore: "متجري",
      myProducts: "منتجاتي",
      addProduct: "إضافة منتج",
      adminPanel: "لوحة الإدارة",
      supportChat: "التحدث مع الدعم",
      helpCenter: "مركز المساعدة",
      logout: "تسجيل الخروج",
      products: "المنتجات",
      stores: "المتاجر",
      categories: "التصنيفات",
    },
    branpy: { title: "BRANPY v3.0", search: "البحث عن الأدوات...", new: "جديد", favorites: "المفضلة", all: "الكل", back: "رجوع", categories: { create: "إنشاء", ai: "الذكاء الاصطناعي", business: "أعمال", marketing: "تسويق", developer: "مطور", media: "وسائط", productivity: "إنتاجية", automation: "أتمتة", cloud: "سحابة", future: "مختبرات" } },
  },

  hi: {
    common: { loading: "लोड हो रहा है...", error: "त्रुटि", success: "सफलता", save: "सहेजें", cancel: "रद्द करें", confirm: "पुष्टि करें", search: "खोजें", back: "वापस", next: "अगला", close: "बंद करें", send: "भेजें", delete: "हटाएं", edit: "संपादित करें", view: "देखें", noResults: "कोई परिणाम नहीं मिला", seeMore: "और देखें", learnMore: "और जानें", startNow: "अभी शुरू करें", createAccount: "खाता बनाएं", login: "लॉग इन", logout: "लॉग आउट", register: "पंजीकरण करें", profile: "प्रोफ़ाइल", settings: "सेटिंग्स", help: "सहायता", support: "समर्थन", home: "होम", explore: "एक्सप्लोर करें", language: "भाषा" },
    nav: { search: "उत्पाद, ब्रांड और अधिक खोजें...", messages: "संदेश", cart: "कार्ट", favorites: "पसंदीदा", notifications: "सूचनाएं", login: "लॉग इन", signup: "पंजीकरण करें", myProfile: "मेरी प्रोफ़ाइल", myOrders: "मेरे ऑर्डर", wallet: "वॉलेट", dashboard: "डैशबोर्ड", myStore: "मेरी दुकान", myProducts: "मेरे उत्पाद", addProduct: "उत्पाद जोड़ें", adminPanel: "एडमिन पैनल", supportChat: "सहायता से बात करें", helpCenter: "सहायता केंद्र", logout: "लॉग आउट", products: "उत्पाद", stores: "दुकानें", categories: "श्रेणियाँ" },
    branpy: { title: "BRANPY v3.0", search: "उपकरण खोजें...", new: "नया", favorites: "पसंदीदा", all: "सभी", back: "वापस", categories: { create: "बनाएं", ai: "AI", business: "व्यवसाय", marketing: "मार्केटिंग", developer: "डेवलपर", media: "मीडिया", productivity: "उत्पादकता", automation: "ऑटोमेशन", cloud: "क्लाउड", future: "लैब्स" } },
  },
};

export default translations;
